import { AppointmentType, Clinic } from 'kb-shared/types';

import { containsOnlyVirtualAppointmentType } from './validation';
import { StepType } from '../types/types';

export const shouldSkipLocationStep = ({
  step,
  selectedAppointmentTypes,
  selectedClinic,
  partnerClinicSearch,
  inClinicTimeSlotsExist
}: {
  step: StepType;
  selectedAppointmentTypes: Array<AppointmentType>;
  selectedClinic: Clinic | undefined;
  partnerClinicSearch: string;
  inClinicTimeSlotsExist: boolean;
}): boolean => {
  if (partnerClinicSearch === 'search') return false;

  if (
    (step === 'location' &&
      (containsOnlyVirtualAppointmentType(selectedAppointmentTypes ?? []) || selectedClinic)) ||
    !inClinicTimeSlotsExist
  ) {
    return true;
  }

  return false;
};
